export default __webpack_public_path__ + "static/quote-icon-eca5422c5af865163aac05417a1ca81a.png";